import { createIcon } from '../create-icon'

export const RankedCrown = createIcon('RankedCrown', ({ strokeWidth }) => (
  <>
    <path
      d="M2 8l4 4 4-6 4 6 4-4-2 12H4L2 8Z"
      strokeWidth={strokeWidth}
    />
    <circle cx="8" cy="17" r="1" strokeWidth={strokeWidth} />
    <circle cx="12" cy="17" r="1" strokeWidth={strokeWidth} />
    <circle cx="16" cy="17" r="1" strokeWidth={strokeWidth} />
  </>
))
